import React from 'react';
import { connect } from 'react-redux'

import { Modal, Button, Alert, Typography, message, Divider } from 'antd';
import { CameraOutlined, FileDoneOutlined, RetweetOutlined } from '@ant-design/icons';
import { _getBase64Upload, _setAxios, _success, _getDistance } from '../../lib/Helper';
import moment from 'moment';

import "./Absensi.css"
import { isMobile } from 'react-device-detect';
import CameraComponent from 'pages/camera/Camera';

const { Text } = Typography;
const dateNow = moment(new Date()).format("DD MMM YYYY")

class AbsensiCheckLog extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            loading: false,
            typeAbsensi: null,
            coordinate: {
                latitude: "",
                longitude: "",
                log: null
            },
            capturImage: null,
            values: {},
            absensiCheckLog: {
                data: {},
                visible: false,
                loading: true
            },
            currentTime: new Date(),
            switchCamera: false,
            isCameraAvailable: true,
            messageCameraError: '',
        };
        this.cam = React.createRef(null);
        this.getMyLocation = this.getMyLocation.bind(this)

    }

    getMyLocation() {
        const location = window.navigator && window.navigator.geolocation

        this.setState({
            coordinate: {
                latitude: "",
                longitude: "",
                log: location
            }
        })

        if (location) {
            location.getCurrentPosition((position) => {
                this.setState({
                    coordinate: {
                        latitude: position.coords.latitude,
                        longitude: position.coords.longitude,
                    }
                })
            }, (error) => {
                this.setState({ latitude: 'err-latitude', longitude: 'err-longitude' })
            })
        }
    }

    getAbsensiById = async (id) => {
        if (!id) {
            return [];
        }
        this.setState({
            absensiCheckLog: {
                ...this.state.absensiCheckLog,
                loading: true
            }
        })
        return await _setAxios("presensi/siswa/temporary/" + id + "/" + dateNow, "GET", null, null, "Data tidak ditemukan").then((resp) => {
            if (resp.status && resp.data) {
                this.setState({
                    absensiCheckLog: {
                        data: resp.data.data,
                        visible: true,
                        loading: false
                    }
                })
            } else {
                this.setState({
                    absensiCheckLog: {
                        ...this.state.absensiCheckLog,
                        loading: false
                    }
                })
            }

            return resp;
        }).catch((err) => {
            this.setState({
                absensiCheckLog: {
                    ...this.state.absensiCheckLog,
                    loading: false
                }
            })
            return err;
        });
    };

    handleChangeSetValue = (name, value) => {
        const { values } = this.state;
        this.setForm(values, name, value)
    };

    setForm = (values, name, value) => {
        values[name] = value;

        this.setState({
            values: values,
        });
    }

    handleSubmit = async () => {
        const { absensiCheckLog } = this.state
        const { privilege } = this.props
        const { presensi, tahun_ajaran, semester, profile_ex } = privilege
        const presensiSetting = presensi?.setting

        if (!this.state.capturImage) {
            return
        }

        let file = await _getBase64Upload(this.state.capturImage)
        if (!file) {
            this.setState({
                loading: false
            })
            return message.warning("Foto selfi wajib ada.");
        }

        this.setState({
            loading: true
        });

        let lat = this.state.coordinate ? this.state.coordinate.latitude : null
        let long = this.state.coordinate ? this.state.coordinate.longitude : null
        var distance = _getDistance([parseFloat(presensiSetting?.lat), parseFloat(presensiSetting?.long)], [lat, long])

        const params = {
            tahun_ajaran_id: tahun_ajaran?.id,
            semester_id: semester?.id,
            siswa_id: profile_ex?.siswa_id,
            rombel_id: profile_ex?.rombel_id,
            tgl: dateNow,
            waktu: this.state.currentTime.toLocaleTimeString(),
            lat: lat,
            long: long,
            radius: distance,
            foto: file,
        }

        if (presensiSetting?.radius_active === "1" && distance > parseFloat(presensiSetting?.radius)) {
            this.setState({
                loading: false
            })
            return message.warning("Mohon maaf jarak kamu tidak terjangkau, pastikan lokasi kamu sudah sesuai.");
        }

        let endpoint = "presensi/siswa/temporary"
        let method = "POST"
        if (absensiCheckLog.data && absensiCheckLog.data.id) {
            endpoint = endpoint + "/" + absensiCheckLog.data.id
            method = "PUT"
        }

        _setAxios(endpoint, method, params).then(resp => {
            if (resp.status === true) {
                _success('topRight', 'Success', resp.data.message)
                setTimeout(() => {
                    window.location.reload(false);
                }, 1000);
            } else {
                this.setState({
                    loading: false
                });
            }
        })
    };

    handleType = (typeAbsensi) => {
        this.setState({
            typeAbsensi: typeAbsensi
        })

        if (typeAbsensi) {
            setTimeout(() => {
                this.setState({
                    isVisibleIframe: true
                })
            }, 3000)
        } else {
            this.setState({
                isVisibleIframe: false,
                loading: false,
                capturImage: null
            })
        }

        if (typeAbsensi) {
            this.handleSubmit()
        }
    }

    capture = (imgSrc) => {
        // console.log(imgSrc);
    }

    setSwitchCamera = () => {
        this.setState({
            switchCamera: !this.state.switchCamera
        })
    }

    componentDidMount() {
        this.getMyLocation()
        this.getAbsensiById(this.props.privilege?.profile_ex?.siswa_id)

        this.intervalId = setInterval(() => {
            this.setState({ currentTime: new Date() });
        }, 500);
    }


    componentWillUnmount() {
        clearInterval(this.intervalId);
    }


    render() {
        const { absensiCheckLog } = this.state
        const { privilege } = this.props
        const { presensi } = privilege
        const presensiSetting = presensi?.setting

        const { capturImage, coordinate, typeAbsensi } = this.state
        const btnBack = <span><Button
            onClick={this.handleType.bind(true, null)}
        >Batal</Button>&nbsp;</span>

        const btnClockIn = !absensiCheckLog.data ? <Button
            type="primary"
            htmlType="submit"
            onClick={this.handleType.bind(true, "clock-in")}
            loading={this.state.loading}
        >Clock</Button> : ""

        const btnClockOut = absensiCheckLog.data ? <Button
            type="primary"
            htmlType="submit"
            onClick={this.handleType.bind(true, "clock-out")}
            loading={this.state.loading}
        >Clock</Button> : ""

        return (
            <Modal
                style={{ textAlign: "center", top: isMobile ? 0 : 32 }}
                maskClosable={false}
                title={<><FileDoneOutlined /> Rekam Kehadiran</>}
                open={this.props.visible}
                onCancel={this.props.hideModal}
                footer={<div
                    style={{ textAlign: "center" }}
                >
                    {typeAbsensi === "clock-in" ? <>{btnBack}{capturImage ? btnClockIn : null}</> : (typeAbsensi === "clock-out" ? <>{btnBack}{capturImage ? btnClockOut : null}</> : <>{btnClockIn} {btnClockOut}</>)}
                </div>}
            >
                {!typeAbsensi ? <>
                    <Text type="secondary">Jadwal: {dateNow + " " + this.state.currentTime.toLocaleTimeString()}</Text>
                    <br />
                    <Text strong>{presensiSetting?.jam_masuk} - {presensiSetting?.jam_pulang}</Text>
                    <Alert style={{ fontSize: "70%" }} message="Foto selfi di perlukan untuk Clock In/Out" type="info" showIcon />
                </> :
                    <>
                        <Text type="secondary">Jadwal: {dateNow + " " + this.state.currentTime.toLocaleTimeString()}</Text>
                        <br />
                        <Text strong>{presensiSetting?.jam_masuk} - {presensiSetting?.jam_pulang}</Text>
                        {capturImage ? null :
                            <div className="content-camera">
                                <CameraComponent setCapturedImage={(img) => this.setState({ capturImage: img })} />
                                {this.state.capturImage && <Button style={{ marginTop: 8 }} type="dashed" icon={<RetweetOutlined />} onClick={this.setSwitchCamera}>Ganti Kamera</Button>}
                            </div>
                        }
                        {capturImage ?
                            <>
                                {(!coordinate.latitude || !coordinate.longitude) ? <Text type="danger"><br />Lokasi belum terdeteksi. <br/>Pastikan untuk mengizinkan akses lokasi. <br/>Mohon tunggu beberapa saat kemudian coba Perbarui Lokasi atau refresh halaman</Text> : <>
                                    <iframe title={"Coordinate user"}
                                        src={"https://maps.google.com/maps?rand=1&q=" + (coordinate.latitude ? coordinate.latitude : 0) + "," + (coordinate.longitude ? coordinate.longitude : 0) + "&hl=id&z=15&output=embed"}
                                        style={{ width: "100%", border: 0, borderRadius: 4 }}
                                        height="180" loading="lazy">
                                    </iframe>
                                    <div>latitude: {coordinate.latitude}</div>
                                    <div>longitude: {coordinate.longitude}</div>
                                </>
                                }
                                <br/>
                                <Button onClick={this.getMyLocation} style={{ marginTop: 8 }} type="dashed" icon={<RetweetOutlined />}>Perbarui Lokasi</Button>
                                <Divider />
                                <a href={capturImage} download>
                                    <img src={capturImage} alt="" style={{ width: '100%' }} />
                                </a>
                                <Button
                                    style={{ marginTop: 8 }}
                                    type="dashed"
                                    icon={<CameraOutlined />}
                                    onClick={() => this.setState({
                                        capturImage: null
                                    })}
                                >Ganti Foto</Button>
                            </> : null}
                    </>
                }

            </Modal>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        privilege: state.privilege,
    }
}

export default connect(mapStateToProps)(AbsensiCheckLog);